"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BasicLogger_1 = require("./BasicLogger");
const format_1 = require("./format");
const SafeLogger_1 = require("./SafeLogger");
const createSafeLogger = (logger) => {
    const basicLogger = new BasicLogger_1.default({
        level: 'info',
        // eslint-disable-next-line no-console
        destination: console.error,
        formatter: format_1.default,
    });
    return logger ? new SafeLogger_1.default(logger, basicLogger) : basicLogger;
};
exports.default = createSafeLogger;
//# sourceMappingURL=createSafeLogger.js.map